__webpack_require__.p = "/dev/bikeshed-strings-and-showcase/";